export default __webpack_public_path__ + "static/media/users-02.39414f2c.png";